import { useCallback, useEffect, useRef, useState, type SyntheticEvent } from "react";

export const useImageLoadState = (src?: string) => {
  const [hasError, setHasError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    setHasError(false);
  }, [src]);

  const isStaleTarget = (target: HTMLImageElement) => target !== imgRef.current;

  const onLoad = useCallback((event: SyntheticEvent<HTMLImageElement>) => {
    if (isStaleTarget(event.currentTarget)) return;
    setHasError(false);
  }, []);

  const onError = useCallback((event: SyntheticEvent<HTMLImageElement>) => {
    if (isStaleTarget(event.currentTarget)) return;
    setHasError(true);
  }, []);

  return { imgRef, hasError, onLoad, onError };
};
